import React from "react";

function SecurityIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3080_1444)">
        <path
          d="M15.5908 2.91283C14.0142 2.12866 12.0833 1.66699 10 1.66699C7.91667 1.66699 5.98667 2.12866 4.40917 2.91283C3.63583 3.29783 3.24917 3.49033 2.875 4.09533C2.50083 4.70033 2.5 5.28616 2.5 6.45699V9.36533C2.5 14.1012 6.285 16.7345 8.4775 17.862C9.08917 18.1762 9.39417 18.3337 10 18.3337C10.6058 18.3337 10.9108 18.1762 11.5225 17.862C13.7142 16.7337 17.5 14.1003 17.5 9.36449V6.45699C17.5 5.28616 17.5 4.70033 17.125 4.09533C16.75 3.49033 16.3642 3.29783 15.5908 2.91283Z"
          stroke="#424242"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.0001 7.49967V8.33301M9.16675 7.91634C9.16675 8.13735 9.25455 8.34932 9.41083 8.5056C9.56711 8.66188 9.77907 8.74967 10.0001 8.74967C10.2211 8.74967 10.4331 8.66188 10.5893 8.5056C10.7456 8.34932 10.8334 8.13735 10.8334 7.91634C10.8334 7.69533 10.7456 7.48337 10.5893 7.32709C10.4331 7.17081 10.2211 7.08301 10.0001 7.08301C9.77907 7.08301 9.56711 7.17081 9.41083 7.32709C9.25455 7.48337 9.16675 7.69533 9.16675 7.91634Z"
          stroke="#424242"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.625 11.6667H9.375L10 8.75L10.625 11.6667Z"
          stroke="#424242"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3080_1444">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SecurityIcon;
